import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import { handleMultiDateBookings } from "../Bookings2/Helper";
import { getClass, teacherResponse } from "../../Helper";
import { uniqBy } from "lodash";
import Auth from "../../Auth/Auth";

const initialExportBookingPopupState = {
  export_booking_popup: false,
  export_booking_start_date: moment(new Date()).format("YYYY-MM-DD"),
  export_booking_end_date: moment(new Date()).format("YYYY-MM-DD"),
};

const classList = getClass();

const useTeacherCalendar = (props) => {
  const calendarRef = useRef();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [bookingStates, setBookingStates] = useState({})
  const [isOpenBookingModal, setIsOpenBookingModal] = useState(false);
  const [state, setState] = useState({
    data: "",
    isPopUp: false,
    isBookingPopUp: false,
    user: props.user,
    selected_date: "",
    schedules: [],
    from_date: "",
    to_date: "",
    gcal_events: "",
    isCalendarPopup: false,
    today: moment(new Date()).format("DD-MM-YYYY"),
    view: "month",
    visibleWeeksCount: 0,
    isWorkWeek: true,
    check_morning: "",
    check_afternoon: "",
    check_evening: "",
    check_all: "",
    check_none: "",
    toggleWeekend: "Show Weekend",
    campuses: [],
    institutions: [],
    startDate: moment(new Date())
      .startOf("month")
      .add(-1, "days")
      .startOf("month")
      .format("YYYY-MM-DD"),
    endDate: moment(new Date())
      .endOf("month")
      .add(1, "days")
      .endOf("month")
      .format("YYYY-MM-DD"),
    loadedMonth: [],
    isFetchDataBooking: false,
    originalBookings: [],
    ...initialExportBookingPopupState,
  });
  const [user, setUser] = useState();
  const handleRenderDate = () => {
    const calendarInstance = calendarRef.current.getInstance();
    setState((preState) => ({
      ...preState,
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    }));
  };

  const handleOpenBooking = () => {
    setIsOpenBookingModal(true);
  };

  const handleCloseBooking = () => {
    setIsOpenBookingModal(false);
  };

  const getGridCategoryTemplate = (category, schedule) => {
    var tpl;
    // eslint-disable-next-line default-case
    switch (category) {
      case "allday":
        tpl =
          '<span class="calendar-font-icon ic-milestone-b"></span> <span style="background-color: ' +
          schedule?.bgColor +
          '">' +
          schedule?.title +
          "</span>";
        break;
      case "task":
        tpl = "#" + schedule?.title;
        break;
    }
    return tpl;
  };

  const handleClickPrevButton = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.prev();
    setState((preState) => ({
      ...preState,
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    }));
    getDate(calendarInstance._renderDate._date);
  };

  const handleClickNextButton = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.next();
    setState((preState) => ({
      ...preState,
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    }));
    getDate(calendarInstance._renderDate._date);
  };

  const isMonthLoaded = (year, month) => {
    return state.loadedMonth.includes(`${year}-${month}`);
  };

  const loadRangeOfMonths = (startDate, endDate) => {
    // Convert the start and end dates to Moment objects
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const loadedMonths = [];
    // Loop through each month in the range and load the data if it hasn't been loaded before
    let currentMoment = startMoment.clone();
    while (currentMoment <= endMoment) {
      const year = currentMoment.year();
      const month = currentMoment.month() + 1; // add 1 to convert from 0-indexed to 1-indexed
      if (!isMonthLoaded(year, month)) {
        loadedMonths.push(`${year}-${month}`);
      }
      currentMoment = currentMoment.add(1, "months");
    }

    return loadedMonths;
  };

  const getDate = (date) => {
    const currentDate = moment(date);
    const currentYear = currentDate.year();
    const currentMonth = moment(date).format("M"); // Add 1 because getMonth() returns 0-indexed months
    // Check if the previous month is loaded
    const previousMonth = moment(date)
      .startOf("month")
      .subtract(1, "days")
      .format("M");

    const previousMonthYear = moment(date)
      .startOf("month")
      .subtract(1, "days")
      .year();
    const previousMonthLoaded = state.loadedMonth.includes(
      previousMonthYear + "-" + previousMonth
    );
    // Check if the next month is loaded
    const nextMonth = moment(date).endOf("month").add(1, "days").format("M");
    const nextMonthYear = moment(date).endOf("month").add(1, "days").year();
    const nextMonthLoaded = state.loadedMonth.includes(
      nextMonthYear + "-" + nextMonth
    );
    // Check if the current month is loaded
    const currentMonthLoaded = state.loadedMonth.includes(
      currentYear + "-" + currentMonth
    );

    if (previousMonthLoaded && currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the next month
      // Set the new end date to the last day of the next month
      const nextMonthStartDate = moment(date)
        .endOf("month")
        .add(1, "days")
        .startOf("month")
        .format("YYYY-MM-DD");
      const nextMonthEndDate = moment(date)
        .endOf("month")
        .add(1, "days")
        .endOf("month")
        .format("YYYY-MM-DD");

      const loadMonths = loadRangeOfMonths(
        nextMonthStartDate,
        nextMonthEndDate
      );
      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: nextMonthStartDate,
        endDate: nextMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    } else if (nextMonthLoaded && currentMonthLoaded && !previousMonthLoaded) {
      // Load data for the previous month
      const previousMonthStartDate = moment(date)
        .startOf("month")
        .subtract(1, "days")
        .startOf("month")
        .format("YYYY-MM-DD");
      const previousMonthEndDate = moment(date)
        .startOf("month")
        .subtract(1, "days")
        .endOf("month")
        .format("YYYY-MM-DD");

      const loadMonths = loadRangeOfMonths(
        previousMonthStartDate,
        previousMonthEndDate
      );
      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: previousMonthStartDate,
        endDate: previousMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    } else if (previousMonthLoaded && nextMonthLoaded && !currentMonthLoaded) {
      // Load data for the current month
      const currentStartDate = moment(date)
        .startOf("month")
        .format("YYYY-MM-DD");
      const currentMonthEndDate = moment(date)
        .endOf("month")
        .format("YYYY-MM-DD");

      const loadMonths = loadRangeOfMonths(
        currentStartDate,
        currentMonthEndDate
      );
      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: currentStartDate,
        endDate: currentMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    } else if (previousMonthLoaded && !currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the current and next months
      const currentStartDate = moment(date)
        .startOf("month")
        .format("YYYY-MM-DD");
      const nextMonthEndDate = moment(date)
        .endOf("month")
        .add(1, "days")
        .endOf("month")
        .format("YYYY-MM-DD");

      const loadMonths = loadRangeOfMonths(currentStartDate, nextMonthEndDate);

      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: currentStartDate,
        endDate: nextMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    } else if (nextMonthLoaded && !previousMonthLoaded && !currentMonthLoaded) {
      // Load data for the current and previous months
      const previousMonthStartDate = moment(date)
        .startOf("month")
        .subtract(1, "days")
        .startOf("month")
        .format("YYYY-MM-DD");
      const currentMonthEndDate = moment(date)
        .endOf("month")
        .format("YYYY-MM-DD");

      const loadMonths = loadRangeOfMonths(
        previousMonthStartDate,
        currentMonthEndDate
      );

      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: previousMonthStartDate,
        endDate: currentMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    } else if (
      !previousMonthLoaded &&
      !currentMonthLoaded &&
      !nextMonthLoaded
    ) {
      // Load data for all three months
      const previousMonthStartDate = moment(date)
        .startOf("month")
        .subtract(1, "days")
        .startOf("month")
        .format("YYYY-MM-DD");
      const nextMonthEndDate = moment(date)
        .endOf("month")
        .add(1, "days")
        .endOf("month")
        .format("YYYY-MM-DD");
      const loadMonths = loadRangeOfMonths(
        previousMonthStartDate,
        nextMonthEndDate
      );

      setState((preState) => ({
        ...preState,
        isFetchDataBooking: true,
        startDate: previousMonthStartDate,
        endDate: nextMonthEndDate,
        loadedMonth: [...preState.loadedMonth, ...loadMonths],
      }));
    }
  };

  const onViewChange = (event) => {
    if (event.target.value === "2 weeks") {
      setState((preState) => ({
        ...preState,
        visibleWeeksCount: 2,
        view: "month",
      }));
    } else if (event.target.value === "month") {
      setState((preState) => ({
        ...preState,
        visibleWeeksCount: 0,
        view: event.target.value,
      }));
    } else {
      setState((preState) => ({
        ...preState,
        view: event.target.value,
      }));
    }
  };

  const handleClickTodayButton = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.today();
    setState((preState) => ({
      ...preState,
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    }));

    setTimeout(() => {
      document
        .querySelector(".tui-full-calendar-today")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);
  };

  const onHideWeekend = () => {
    setState((preState) => ({
      ...preState,
      isWorkWeek: !preState?.isWorkWeek,
      toggleWeekend:
        preState?.toggleWeekend === "Hide Weekend"
          ? "Show Weekend"
          : "Hide Weekend",
    }));
  };

  const handlePickMonth = (date) => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.setDate(date);
    setState((preState) => ({
      ...preState,
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    }));
    getDate(date);
  };

  const getTeacherDetail = async () => {
    try {
      const response = await API.getUserSafeDataById(
        searchParams.get("teacher_id")
      );
      setUser(response?.data?.user);
    } catch (error) {
      notify.show(error?.response?.data?.message);
    }
  };

  const getTeacherAvailabilityFromBooking = (booking) => {
    const { end_time } = booking;
    if (end_time <= "15:00:00") {
      return "Morning";
    } else {
      return "Evening";
    }
  };

  const getClassName = (key) => {
    const cls = classList.find((cl) => cl.key === key) || {};
    return cls.whole_name;
  };

  const getAmPmEve = (timeString) => {
    const timeArray = timeString?.split(":");
    let hour = parseInt(timeArray[0]);
    return hour < 12 ? "AM" : hour < 15 ? "PM" : "EVE";
  };

  const setInterviewSchedule = (interviewSchedules) => {
    if (interviewSchedules <= 0) return;
    let events = [];
    interviewSchedules.forEach((interview) => {
      const inst = state.institutions.find(
        (ins) => ins._id === interview.inst_id
      );
      const interview_sche = {
        id: interview._id,
        calendarId: 2,
        title: interview.title + " Interview",
        category: "allday",
        dueDateClass: "",
        bgColor: "#0c05cc",
        isReadOnly: true,
        start: new Date(interview.scheduleInfos.preferred_time),
        end: new Date(interview.scheduleInfos.preferred_time),
        location:
          interview.scheduleInfos.preferred_location === "online"
            ? interview.scheduleInfos.meeting_link
            : interview.scheduleInfos.campus +
              ", " +
              (inst ? inst.institution_name : ""),
        state:
          interview.scheduleInfos.preferred_location === "online"
            ? "Online"
            : "On Campus",
        body: JSON.stringify({
          start_time: interview.scheduleInfos.preferred_time,
        }),
      };
      events.push(interview_sche);
    });
    setState((preState) => {
      let newSchedule = [];
      if (preState?.schedules) {
        newSchedule = [...preState?.schedules, ...events];
      } else {
        newSchedule = events;
      }
      return {
        ...preState,
        gcal_events: events,
        schedules: newSchedule,
      };
    });
  };

  const setBookingEvents = (bookings) => {
    if (bookings.length <= 0) return;
    let events = [];
    bookings.forEach((booking) => {
      const title = "Booked" + " " + getAmPmEve(booking?.start_time);
      let inst;
      let campus = state.campuses.find((cam) => cam._id === booking.campus_id);

      if (!campus || (!campus._id && booking.campus)) {
        campus = booking.campus;
      }

      if (campus) {
        inst = state.institutions.find(
          (ins) => ins._id === campus.institution_id
        );
      }

      if (booking.multiple_date) {
        const dates =
          booking.dates.filter(function (dates) {
            return (
              dates.date >= booking.booking_date &&
              dates.date <= booking.end_booking_date
            );
          }) || [];
        dates.forEach((date) => {
          // use original_dates instead of dates to find the correct index of date
          const indexItem = booking.original_dates.find(
            (item) => item.date === date.date
          );
          const index = booking.original_dates.indexOf(indexItem);
          if (!date.cancelled_by_inst && !date.teacher_cancel_reason) {
            if (date.teacher_id === searchParams.get("teacher_id")) {
              const booking_sche = {
                id: `${booking._id}_${index}`,
                calendarId: 1,
                title: title,
                category: "allday",
                dueDateClass: "",
                isReadOnly: true,
                start: new Date(date.date),
                end: new Date(date.date),
                location:
                  inst || campus
                    ? `${
                        campus.address_line1 +
                        (campus.address_line2
                          ? ", " + campus.address_line2
                          : "")
                      }, ${inst?.institution_name}`
                    : "",
                state: booking.online ? "Online" : "On Campus",
                body: JSON.stringify({
                  arrival_time: date.arrival_time
                    ? date.arrival_time
                    : booking.arrival_time,
                  start_time: date.start_time
                    ? date.start_time
                    : booking.start_time,
                  end_time: date.end_time ? date.end_time : booking.end_time,
                  // isAdmin: this.props.isAdmin,
                }),
              };

              let duplication = false;
              for (let e of events) {
                if (booking._id === e.id) {
                  duplication = true;
                  break;
                }
              }
              if (!duplication) {
                events.push(booking_sche);
              }
            }
          }
        });
      } else {
        events.push({
          id: booking._id,
          calendarId: 1,
          title: title,
          category: "allday", //'milestone', 'task', allday', 'time'
          dueDateClass: "START",
          borderColor: "#fff",
          isReadOnly: true,
          start: new Date(booking.booking_date),
          end: new Date(booking.booking_date),
          location: inst
            ? `${campus.campus_shortname}, ${inst.institution_name}`
            : "",
          state: booking.online ? "Online" : "On Campus",
          body: JSON.stringify({
            arrival_time: booking.arrival_time,
            start_time: booking.start_time,
            end_time: booking.end_time,
            // isAdmin: this.props.isAdmin,
          }),
        });
      }
    });

    setState((preState) => {
      let scheduleslist = [];
      if (preState?.schedules) {
        const itemWithID = [...preState?.schedules, ...events].filter(
          (item) => item.id
        );
        const itemWithoutID = [...preState?.schedules, ...events].filter(
          (item) => !item.id
        );
        scheduleslist = [...itemWithoutID, ...uniqBy([...itemWithID], "id")];
      } else {
        scheduleslist = events;
      }
      return {
        ...preState,
        gcal_events: events,
        originalBookings: bookings,
        schedules: scheduleslist,
      };
    });
  };

  const getAllInstWithCache = async () => {};

  const showPermissionDeniedNotification = (history, path) => {
    notify.show("You do not have permission to access this.")
    history.push(path)
  }

  const fetchData = async () => {
    if (!user) return;
    setTimeout(() => {
      if (document.querySelector(".tui-full-calendar-today")) {
        document
          .querySelector(".tui-full-calendar-today")
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);

    const role = Auth.verifyUserRole();
    const path = role === "customer" ? "/CollegeDashboard" : "/PersonnelDashboard";

    const requestStatus = await API.checkValidRequestViewCalendarV2(
      searchParams.get("teacher_id")
    ).then((res) => {
      return res?.data?.data?.status;
    }).catch(() => {
      showPermissionDeniedNotification(props.history, path)
      return;
    });

    if (requestStatus !== "accepted") {
      showPermissionDeniedNotification(props.history, path)
      return;
    }

    const [instList, campusList, bookingList, schedules] = await Promise.all([
      (async () => {
        const result = await API.getAllInstWithCache();
        return result.data.map((inst) => {
          return {
            _id: inst._id,
            institution_name: inst.institution_name,
          };
        });
      })(),
      (async () => {
        const result = await API.getAllCampusWithCache();
        return result.data.map((campus) => {
          return {
            _id: campus._id,
            campus_shortname: campus.campus_shortname,
            address_line1: campus.address_line1,
            address_line2: campus.address_line2,
            institution_id: campus.institution_id,
          };
        });
      })(),
      (async () => {
        const loadedMonths = loadRangeOfMonths(state.startDate, state.endDate);
        setState((preState) => ({
          ...preState,
          loadedMonth: [...preState.loadedMonth, ...loadedMonths],
        }));

        const result = await API.getAllBookingsByTeacherIDPagination(
          searchParams.get("teacher_id"),
          ["rejected", "cancelled"],
          state.startDate,
          state.endDate
        );
        return handleMultiDateBookings(
          result?.data,
          searchParams.get("teacher_id")
        ).filter((booking) => {
          return (
            !booking.cancelled_by_inst &&
            booking.teacher_response !== teacherResponse.not_responded &&
            booking.teacher_response !== teacherResponse.rejected
          );
        });
      })(),
      (async () => {
        const result = await API.getViewCalendarApplicationsV2(
          searchParams.get("teacher_id")
        );
        const jobListings = result.data.listings;
        let schedules = [];
        if (jobListings.length > 0) {
          schedules = jobListings.filter((listing) => {
            const scheduleInfos = listing.invited_interview?.find(
              (int) => int.teacher_id === user._id
            )?.interview_schedule_infos;
            if (scheduleInfos) {
              for (let i = 0; i < scheduleInfos.length; i++) {
                if (
                  scheduleInfos[i].status === "selected" &&
                  scheduleInfos[i].preferred_time
                ) {
                  listing.scheduleInfos = scheduleInfos[i];
                  return true;
                }
              }
            }
            return false;
          });
        }
        return schedules;
      })(),
    ]);

    if (user.rules?.[0]) {
      const rules = user.rules[0];
      state.originalBookings.forEach((booking) => {
        const date = booking?.end_booking_date?.split("-").reverse().join("-");
        const rule = rules[date];
        const bookingTime = getTeacherAvailabilityFromBooking(booking);
        if (rule) {
          let newTime = rule.time;
          const index = rule.time.indexOf(bookingTime);
          if (index >= 0) {
            newTime = [
              ...rule.time.slice(0, index),
              ...rule.time.slice(index + 1),
            ];
          }
          if (newTime?.length) {
            rules[date] = {
              ...rules[date],
              time: newTime,
            };
          } else {
            delete rules[date];
          }
        }
      });

      const result = Object.keys(rules).map(function (key) {
        if (rules[key]) {
          return {
            title:
              rules[key].time.length === 4 ||
              (rules[key].time.length === 3 &&
                !rules[key]?.time?.includes("All"))
                ? "All Day"
                : rules[key].time?.filter((item) => item !== "All").toString(),
            category: "time",
            dueDateClass: "",
            borderColor: "#fff",
            start: moment.utc(rules[key].date, "DD-MM-YYYY").toDate(),
            end: moment.utc(rules[key].date, "DD-MM-YYYY").toDate(),
          };
        }
      });
      setState((preState) => ({
        ...preState,
        institutions: instList,
        campuses: campusList,
        schedules: result,
      }));
    }
    setBookingEvents(bookingList);
    setInterviewSchedule(schedules);
  };

  const fetchAllBookings = async () => {
    const { startDate, endDate } = state;
    try {
      if (state.isFetchDataBooking) {
        const response = await API.getAllBookingsByTeacherIDPagination(
          searchParams.get("teacher_id"),
          ["rejected", "cancelled"],
          startDate,
          endDate
        );
        const result = handleMultiDateBookings(
          response.data,
          searchParams.get("teacher_id")
        ).filter((booking) => {
          return (
            !booking.cancelled_by_inst &&
            booking.teacher_response !== teacherResponse.not_responded &&
            booking.teacher_response !== teacherResponse.rejected
          );
        });
        setState((preState) => ({ ...preState, isFetchDataBooking: false }));
        setBookingEvents(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTeacherDetail();
  }, []);
  useEffect(() => {
    fetchData();
  }, [user]);

  useEffect(() => {
    fetchAllBookings();
  }, [state.startDate]);
  return {
    ...props,
    calendarRef,
    state,
    user,
    isOpenBookingModal,
    bookingStates,
    setBookingStates,
    handleRenderDate,
    getGridCategoryTemplate,
    handleClickPrevButton,
    handleClickNextButton,
    onHideWeekend,
    onViewChange,
    handleClickTodayButton,
    handlePickMonth,
    handleOpenBooking,
    handleCloseBooking,
  };
};
export default useTeacherCalendar;
